export default function Events() {
  return (
    <div className="card">
      <h1>Events</h1>
      <p>
        Public-facing event highlights live here. Detailed scheduling and
        member-only event information is in the{" "}
        <a href="/members/common">members area</a>.
      </p>
      <ul>
        <li>Annual gathering — see members' page for date/location.</li>
        <li>Quarterly meet-ups — see members' page for invitations.</li>
      </ul>
    </div>
  );
}
